import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { CurrentService } from '../../../../services/current.service';
import { DatasService } from '../../../../services/datas.service';
import { GTM } from 'src/app/services/gtm.service';
import { Router } from '@angular/router';
import { getHbmTotalSteps } from 'src/app/services/helpers/app-context-helper';
import { CustomerService } from 'src/app/services/customer.service';

@Component({
  selector: 'ng-casto-storage-handles',
  templateUrl: './handles.component.html',
})
export class StorageHandlesComponent implements OnInit {
  handles: any[];

  @Output() onComplete: EventEmitter<void> = new EventEmitter();

  constructor(
    public current: CurrentService,
    public datas: DatasService,
    private readonly gtm: GTM,
    private readonly router: Router,
    private readonly customer: CustomerService
  ) { }

  ngOnInit(): void {
    this.gtm.trackPage(`${this.router.url}/choix/poignees`, 'Rangements | Choix', {
      stepNumber: 4,
      totalSteps: getHbmTotalSteps(this.customer.context),
    });

    this.handles = this.datas.storageInspiration.getHandles(
      this.current.storage.inspirationId,
      this.current.storage.boxId,
      this.current.storage.frontId
    );

    if (this.handles.length === 1) {
      this.selectHandles(this.handles[0].id);
    }
  }

  selectHandles(handlesId: number) {
    if (this.current.storage.handlesId !== handlesId) {
      this.current.storage.handlesId = handlesId;
    }

    this.onComplete.emit();
  }
}
